import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Announcement } from './announcement';
import { environment } from '@morningstar/shared/environment';

@Injectable()
export class AnnouncementsService {

  constructor(private httpClient: HttpClient) { }

  get(type: string): Observable<Announcement[]> {
    return this.httpClient.get<Announcement[]>(`${environment.spaceGeekUrl}${environment.api.announcements.get}`
                                              .replace('{type}', type));
  }

  insert(announcement: Announcement): Observable<any> {
    return this.httpClient.post(`${environment.spaceGeekUrl}${environment.api.announcements.base}`, announcement);
  }

  update(announcement: Announcement): Observable<any> {
    return this.httpClient.put(`${environment.spaceGeekUrl}${environment.api.announcements.base}`, announcement);
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(`${environment.spaceGeekUrl}${environment.api.announcements.delete}`
                          .replace('{id}', id.toString()));
  }
}
